import React, { useState } from "react";
import { Heart, Loader2, Lock, User } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { adminApi, setToken, errMsg } from "../lib/api";

export default function AdminLogin({ onLogin }) {
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.username || !form.password) return toast.error("Enter username and password");
    setLoading(true);
    try {
      const { data } = await adminApi.post("/admin/login", form);
      setToken(data.token);
      toast.success("Welcome back!");
      onLogin(data.username);
    } catch (err) {
      toast.error(errMsg(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative admin-login-art">
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
        <div className="absolute bottom-12 left-12 text-white max-w-sm">
          <p className="logo-script !text-[54px]">Silky Maya</p>
          <p className="mt-3 text-white/85 text-[15px] leading-relaxed">Manage every photo on your landing page – hero, about, chat avatar and the full gallery.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-[380px] admin-card p-8 fade-up" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-[#ee3a70]"><Heart className="w-5 h-5" fill="currentColor" /><span className="text-[13px] font-semibold tracking-[0.12em] uppercase">Admin</span></div>
          <h1 className="serif text-[34px] mt-2 text-[#1b1719]">Sign in</h1>
          <p className="text-[14px] text-[#7a7276] mt-1">Access the image manager</p>
          <div className="mt-7 space-y-4">
            <div>
              <Label htmlFor="au">Username</Label>
              <div className="relative mt-1.5">
                <User className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#a79fa3]" />
                <Input id="au" className="pl-9 h-11" data-testid="admin-username" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} autoComplete="username" />
              </div>
            </div>
            <div>
              <Label htmlFor="ap">Password</Label>
              <div className="relative mt-1.5">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#a79fa3]" />
                <Input id="ap" type="password" className="pl-9 h-11" data-testid="admin-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} autoComplete="current-password" />
              </div>
            </div>
          </div>
          <button type="submit" disabled={loading} className="admin-btn w-full mt-7 h-11" data-testid="admin-login-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </button>
          <a href="/" className="block text-center mt-5 text-[13px] text-[#7a7276] hover:text-[#ee3a70]">← Back to site</a>
        </form>
      </div>
    </div>
  );
}
